import React, { useState } from 'react'
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  OutlinedInput,
  InputAdornment
  } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import config from '../config.json'


const default_operations = [{ type: 'Descuento', value: '' }]
const DiscountCalculator = ({title, label, setValue, hideTax, initial_object, submit, ...rest}) => {

  const getDefaultOperations = () => 
    initial_object.elements.length > 0? 
      initial_object.elements.map((value, index) => ({ type: value > 0 ? 'Incremento' : 'Descuento', value: Math.abs(value) })):
      default_operations

  
  const [discount_object, setDiscountObject] = useState(initial_object)
  const [includes_tax, setIncludesTax] = useState(hideTax? null : initial_object.includes_tax?true:false)
  const [operations, setOperations] = useState(getDefaultOperations())

  const handleInputChange = (index, event) => {
    const newOperations = [...operations]
    newOperations[index].value = event.target.value
    setOperations(newOperations)
  }

  const handleTypeChange = (index, event) => {
    const newOperations = [...operations]
    newOperations[index].type = event.target.value
    setOperations(newOperations)
  }

  const handleAddOperation = (type) => {
    setOperations([...operations, { type: type, value: '' }])
  }

  const handleRemoveOperation = (index) => {
    const newOperations = [...operations]
    newOperations.splice(index, 1)
    setOperations(newOperations)
  }

  const handleTaxChange = (value) => setIncludesTax(value)

  const handleCalculateTotalPercentage = () => {
    let totalMultiplier = 1 // Starting with a multiplier of 1
    operations.forEach(operation => {
      const value = parseFloat(operation.value)
      if (!isNaN(value)) {
        if (operation.type === 'Descuento') {
          totalMultiplier *= (1 - (value / 100))
        } else if (operation.type === 'Incremento') {
          totalMultiplier *= (1 + (value / 100))
        }
      }
    })
    if (!includes_tax && !hideTax) {
      totalMultiplier *= config.IVA
    }
    const totalPercentage = (1 - totalMultiplier) * 100
    setDiscountObject({
      value: totalPercentage.toFixed(2), 
      includes_tax,
      elements: operations.map(operation => operation.type == "Incremento" ? operation.value : -1*operation.value),
    })
  }

  const handleDefault = () => {
    setDiscountObject(initial_object)
    setIncludesTax(hideTax? null : initial_object.includes_tax?true:false)
    setOperations(getDefaultOperations())
  }
  React.useEffect(handleDefault, [initial_object])

  React.useEffect(handleCalculateTotalPercentage, [operations, includes_tax])

  return (
    <Container maxWidth="sm">
      <Box my={4}>
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
        {operations.map((operation, index) => (
          <Box key={index} display="flex" alignItems="center" marginTop={2} marginBottom={2} >
            <FormControl variant="outlined" style={{ minWidth: 120, marginRight: '16px' }}>
              <InputLabel>Tipo</InputLabel>
              <Select
                value={operation.type}
                onChange={event => handleTypeChange(index, event)}
                label="Tipo"
              >
                <MenuItem value="Descuento">Descuento</MenuItem>
                <MenuItem value="Incremento">Incremento</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label={`${operation.type} (%)`}
              variant="outlined"
              fullWidth
              value={operation.value}
              onChange={event => handleInputChange(index, event)}
            />
            <IconButton
              color="secondary"
              onClick={() => handleRemoveOperation(index)}
              style={{ marginLeft: '8px' }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
        <Box display="flex" alignItems="start" flexDirection="column">
            <Box>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddOperation('Descuento')}
                    style={{ marginTop: '16px' }}
                    >
                    Añadir Descuento
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddOperation('Incremento')}
                    style={{ marginTop: '16px', marginLeft: '8px' }}
                    >
                    Añadir Incremento
                </Button>
            </Box>
            {!hideTax && 
              <FormControlLabel
                  control={
                      <Checkbox
                      checked={includes_tax}
                      onChange={(event) => handleTaxChange(event.target.checked)}
                      color="primary"
                      />
                  }
                  label="El costo del producto incluye IVA"
              />
            }
        </Box>
        <FormControl sx={{ marginTop: '30px', width: '25ch' }}>
          <InputLabel htmlFor="discount">{label}</InputLabel>
          <OutlinedInput
            id="discount"
            disabled={true}
            value={discount_object.value}
            endAdornment={<InputAdornment position="start">%</InputAdornment>}
            label="Porciento"
          />
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="center" mt={3} mb={3}>
        <Button disabled={isNaN(discount_object.value)} onClick={() => submit(discount_object)}>Actualizar descuento</Button>
      </Box>
    </Container>
  )
}

export default DiscountCalculator
